import { Message } from "./messages/message";
import { Node } from "./node";

export class Results {

    private allSentMsgs: Array<Message> = [];
    private allReceivedMsgs: Array<Message> = [];
    private allDroppedMsgs: Array<Message> = [];
    private allMsgsRoutes: Array<Array<Node>> = [];

    public simTime: number = 0;
    public numMsgsSent: number = 0;
    public numUniqueMsgsSent: number = 0;
    public numMsgsReceived: number = 0;
    public numMsgsRelayed: number = 0;
    public numMsgsDropped: number = 0; 
    public deliveryProbability: number = 0; 
    public avgLatency: number = 0;
    public avgHopCount: number = 0;
    public medHopCount: number = 0;
    public avgNodeDegree: number = 0;
    public overhead: number = 0;

    constructor(private nodes: Array<Node>, 
                private simStartTime: number, 
                private simEndTime: number) {

        this.calculateAllSentMessages();
        this.calculateAllReceivedMessages();
        this.calculateAllDroppedMessages();
        this.calculateAllMsgsRoutes();

        console.log(this.allSentMsgs);
        console.log(this.allReceivedMsgs);

        this.calculateSimTime();
        this.calculateNumUniqueMsgsSent();
        this.calculateNumMsgsSent();
        this.calculateNumMsgsReceived();
        this.calculateNumMsgsRelayed();
        this.calculateNumMsgsDropped();
        this.calculateDeliveryProbability();
        this.calculateAvgLatency();
        this.calculateAvgHopCount();
        this.calculateMedHopCount();
        this.calculateAvgNodeDegree();
        this.calculateOverhead();
    }

    private calculateAllSentMessages(): void {
        this.nodes.forEach((node: Node) => {
            this.allSentMsgs = [...this.allSentMsgs, ...node.messagingSystem.uniqueSentMessages];
        });
    }

    private calculateAllReceivedMessages(): void {
        this.nodes.forEach((node: Node) => {
            this.allReceivedMsgs = [...this.allReceivedMsgs, ...node.messagingSystem.receivedMessages];
        });
    }

    private calculateAllDroppedMessages(): void {
        this.nodes.forEach((node: Node) => {
            this.allDroppedMsgs = [...this.allDroppedMsgs, ...node.messagingSystem.droppedMessages];
        });
    }

    private calculateAllMsgsRoutes(): void {
        this.nodes.forEach((node: Node) => {
            node.messagingSystem.receivedMessages.forEach((receivedMsg: Message) => {
                this.allMsgsRoutes.push(receivedMsg.routeTaken);
            });
        });
    }

    private calculateSimTime(): void {
        this.simTime = this.simEndTime - this.simStartTime;
    }

    private calculateNumUniqueMsgsSent(): void {
        this.numUniqueMsgsSent = this.allSentMsgs.length;
    }

    private calculateNumMsgsSent(): void {
        this.nodes.forEach((node: Node) => {
            this.numMsgsSent += node.messagingSystem.totalSentMsgCount;
        });

        this.numMsgsSent 
    }


    private calculateNumMsgsReceived(): void {
        this.numMsgsReceived = this.allReceivedMsgs.length;
    }

    private calculateNumMsgsRelayed(): void {
        this.allReceivedMsgs.forEach((msg) => {
            this.numMsgsRelayed += msg.nodesAlreadyReceived.length
        });
    }

    private calculateNumMsgsDropped(): void {
        this.numMsgsDropped = this.allDroppedMsgs.length;
    }

    private calculateDeliveryProbability(): void {
        this.deliveryProbability = this.allReceivedMsgs.length / this.numUniqueMsgsSent;
    }

    private calculateAvgLatency(): void {
        this.avgLatency = this.allReceivedMsgs.map(
            function (x: Message, i, arr) {
                return (x.timeTakenToArrive ?? 1) / arr.length
            }
        ).reduce(function(a, b){ return a + b }, 0);
    }

    private calculateAvgHopCount(): void {
        let totalHopCount = 0;
        
        this.allMsgsRoutes.forEach((route) => {
            // - 2 to remove source and destination nodes, this isn't a hop.
            totalHopCount += (route.length - 2);
        });

        this.avgHopCount = totalHopCount / this.allMsgsRoutes.length;
    }

    private calculateMedHopCount(): void {
        let lengthsOfRoutes: Array<number> = [];

        this.allMsgsRoutes.forEach((route) => {
            lengthsOfRoutes.push(route.length - 2);
        });

        lengthsOfRoutes = lengthsOfRoutes.sort().reverse();
        this.medHopCount = lengthsOfRoutes[Math.floor(lengthsOfRoutes.length / 2)];
    }

    private calculateAvgNodeDegree(): void {
        let totalNodeDegreeAvgs = 0;

        this.nodes.forEach((node: Node) => {
            totalNodeDegreeAvgs += node.messagingSystem.avgNodeDegree;
        });
        
        this.avgNodeDegree = totalNodeDegreeAvgs / this.nodes.length;
    }

    private calculateOverhead(): void {
        this.overhead = this.numMsgsSent - this.allReceivedMsgs.length;
    }

}